'use client';

import { useContext } from 'react';
import { RingSelectionContext } from 'components/ring-air/RingSelectionContext';
import { aeEmirateGroupOf } from './emirates';
import { useAeDeliveryWindow } from './useAeDeliveryWindow';

/**
 * Single composition point for the AE delivery promise: reads the selected
 * emirate from RingSelectionContext, derives the emirate group, and resolves
 * the live GST window for it. All AE ETA surfaces (card, size accordion,
 * order summary, both bottom bars) consume this so they can never disagree
 * on group logic; fallback surfaces take shippingEstimate from the context
 * themselves.
 *
 * @param enabled - the caller's AE visibility gate (region === 'AE' &&
 * AE_DELIVERY_ETA_ENABLED); gates the window timer, see useAeDeliveryWindow.
 */
export const useAeDeliveryEta = (enabled: boolean) => {
  const { selectedEmirate, setSelectedEmirate } =
    useContext(RingSelectionContext);
  const group = aeEmirateGroupOf(selectedEmirate);
  const windowState = useAeDeliveryWindow(enabled, group);

  return {
    selectedEmirate,
    setSelectedEmirate,
    group,
    windowState,
    hasError: windowState === 'error',
  };
};
